import React, { useState } from "react";
import {Fade} from 'react-awesome-reveal';

function Flip(props) {
    return (
      <svg
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-0.02 0.5 24.02 24"
        {...props}
      >
        <g clipPath="url(#clip0_1107_80)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.09 19.792c.248.218.568.339.9.34 1.473.063 2.95-.04 4.4-.31.503-.072.98-.275 1.38-.59a.82.82 0 00.22-.72 7.64 7.64 0 00-1.14-2.57c-.701-1.092-1.48-2.131-2.33-3.11-.393-.442-.78-.886-1.166-1.33a102.4 102.4 0 00-1.935-2.18 31.762 31.762 0 00-2.26-2.23 12.394 12.394 0 00-2.17-1.88 2.59 2.59 0 00-2.38-.12 7.25 7.25 0 00-1.8 1.17c-.48.43-.908.9-1.332 1.367-.237.261-.474.522-.718.773-.88.91-1.67 1.82-2.47 2.76-.8.94-1.57 1.94-2.3 2.94a10.888 10.888 0 00-1 1.6 16.985 16.985 0 00-.74 1.68c-.11.22-.198.451-.26.69a.92.92 0 00.11.54c.214.222.49.375.79.44 1 .3 3.39.86 4.39 1 .235.044.476.044.71 0a.46.46 0 00.32-.36l.23-.338c.981-1.451 3.497-5.169 4.77-6.662.09-.11.186-.214.29-.31a.27.27 0 01.08.07 20.45 20.45 0 011.41 1.77c.944 1.249 2.024 2.79 2.83 3.94.594.847 1.039 1.481 1.17 1.63zm-11.7-.28v.08a.09.09 0 010-.08z"
            fill="#0D3727"
          />
        </g>
        <defs>
          <clipPath id="clip0_1107_80">
            <path fill="#fff" transform="translate(0 .5)" d="M0 0H24V24H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  }
  

const FAQ = (props) => {

    const [isOpen, setIsOpen] = useState(false)

    return(
        <div className="py-[16px]">

            <div className="flex justify-between cursor-pointer" onClick={() => setIsOpen(!isOpen)} >

            <h3 className="faq-title">
                {props.title}
            </h3>

                <Flip className={`w-[24px] h-[24px] transition-transform duration-300 ${isOpen ? `` : `rotate-180`}`}/>

            </div>
            <div className={`transition-all duration-300 overflow-hidden ${isOpen ? `max-h-[1000px]` : `max-h-0`}`}>
                <p className="body-2 pt-[16px]">
                    {props.copy}
                </p>
            </div>


        </div>
    )
}

const FAQs = () => {
    return(
        <section className="container-theme text-[#0D3727] pt-[85px] lg:pt-[60px]" id="faqs">
              <Fade cascade duration={300}>

            <h2 className="h2 uppercase text-center">
            FAQs
            </h2>
            <div className="mt-[50px] lg:mt-[95px] border-y-[2px] border-[#68DDB0] max-w-[920px] mx-auto mb-[105px]">

                <FAQ title={`Is the project still live?`} copy={`Yes. You can still find the Sloths on OpenSea; unfortunately, the utilities and roadmap have halted after the project ran out of funding.`}/>

            </div>
            </Fade>
        </section>
    )
}

export default FAQs